<script lang="ts">import { stateUi } from "@infinitro/config";
$: vipHeaderGlyphDarkFill = $stateUi.icons?.vipHeaderGlyphDarkFill ?? false;
</script>

<svg width="17" height="25" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_910_18573)">
		<g clip-path="url(#clip1_910_18573)">
			<path
				d="M1.86795 14.2341C6.28767 14.2341 10.7074 14.2341 15.1446 14.2341C15.1882 13.9657 15.2318 13.7018 15.2755 13.4335C15.5067 11.9172 15.7423 10.401 15.9823 8.88482C16.0477 8.48228 15.9561 8.13342 15.6158 7.89637C15.2711 7.65932 14.9177 7.68169 14.573 7.90532C13.7528 8.43756 12.9325 8.96533 12.1123 9.49757C12.0686 9.52887 12.0207 9.55571 11.9639 9.59149C11.7196 9.30524 11.4796 9.02347 11.2397 8.7417C10.5678 7.95452 9.89151 7.16287 9.21961 6.37121C8.7964 5.87476 8.20303 5.87923 7.77982 6.37569C6.89849 7.40886 6.01717 8.4465 5.13148 9.48415C5.10093 9.51546 5.07476 9.55124 5.03549 9.59596C4.98313 9.56465 4.93514 9.53335 4.88715 9.50204C4.0669 8.9698 3.24666 8.43756 2.42641 7.90979C1.95085 7.60565 1.4142 7.71747 1.13497 8.1692C1.00408 8.38389 0.977899 8.62093 1.01717 8.86246C1.28767 10.6068 1.55818 12.3466 1.83305 14.0909C1.83741 14.1357 1.85486 14.1804 1.86795 14.2341Z"
				fill={vipHeaderGlyphDarkFill ? 'black' : 'white'}
			/>
			<path
				d="M14.9746 15.3253C10.6552 15.3253 6.34459 15.3253 2.02522 15.3253C2.11248 15.8889 2.18665 16.439 2.29136 16.9847C2.40044 17.5571 2.89782 17.9642 3.48683 17.9955C3.53046 17.9999 3.57409 17.9999 3.61772 17.9999C6.87252 17.9999 10.1273 17.9999 13.3821 17.9999C14.0584 17.9999 14.5907 17.6063 14.7085 16.9891C14.8132 16.4435 14.8873 15.8889 14.9746 15.3253Z"
				fill={vipHeaderGlyphDarkFill ? 'black' : 'white'}
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0_910_18573">
			<rect
				width="17"
				height="17"
				fill={vipHeaderGlyphDarkFill ? 'black' : 'white'}
				transform="translate(0 4)"
			/>
		</clipPath>
		<clipPath id="clip1_910_18573">
			<rect
				width="15"
				height="12"
				fill={vipHeaderGlyphDarkFill ? 'black' : 'white'}
				transform="matrix(-1 0 0 1 16 6)"
			/>
		</clipPath>
	</defs>
</svg>
